import { Fragment } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { formatDate, formatMoney, formatNumber } from "./summary/Utils";

export default function Card(props) {
  const headers = props.row ? Object.keys(props.row) : [];
  const prepareValue = (row, header) => {
    if (row[header] === true) {
      return "Yes";
    }
    if (row[header] === false) {
      return "No";
    }
    if (row[header] === null) {
      return undefined;
    }
    if (header.indexOf("_date") > -1) {
      return formatDate(row[header]);
    }
    if (
      !isNaN(row[header]) &&
      (header.endsWith("value") ||
        header.endsWith("price") ||
        header.endsWith("tax") ||
        header.endsWith("amount") ||
        header.endsWith("rent") ||
        header.endsWith("cost") ||
        header.endsWith("income") ||
        header === "high" ||
        header === "low")
    ) {
      return formatMoney(row[header]);
    }
    if (
      !isNaN(row[header]) &&
      (header.endsWith("ft") ||
        header.endsWith("acres") ||
        header.endsWith("count"))
    ) {
      return formatNumber(row[header]);
    }
    return typeof row[header] === "object"
      ? JSON.stringify(row[header])
      : row[header];
  };
  const prepareHeader = (header) => {
    return header
      .split("_")
      .filter((_) => _)
      .map((_) => _[0].toUpperCase() + _.slice(1))
      .join(" ");
  };
  return (
    <Fragment>
      <Typography variant="h6" color="primary" gutterBottom>
        {props.label}
      </Typography>
      <Table size="small">
        <TableBody>
          {headers.map((header, index) => (
            <TableRow key={index}>
              <TableCell>{prepareHeader(header)}</TableCell>
              <TableCell>{prepareValue(props.row, header)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Fragment>
  );
}
